/**
 * Storage Safety Wrapper
 * 
 * Prevents SecurityError exceptions when third-party scripts (like Pandectes cookie consent)
 * attempt to access sessionStorage/localStorage in restricted browser contexts:
 * - Sandboxed iframes
 * - Private/incognito mode with strict settings
 * - Cross-origin contexts
 * 
 * Fixes Sentry issue: SHOPIFY-STOREFRONT-A4
 * Error: "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document."
 */

(function() {
  'use strict';

  /**
   * Test if storage is available and accessible
   */
  function isStorageAccessible(storage) {
    try {
      const testKey = '__storage_test__';
      storage.setItem(testKey, 'test');
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Create a safe storage stub that won't throw SecurityError
   */
  function createStorageStub() {
    const memoryStorage = {};
    
    return {
      getItem: function(key) {
        return memoryStorage[key] || null;
      },
      setItem: function(key, value) {
        memoryStorage[key] = String(value);
      },
      removeItem: function(key) {
        delete memoryStorage[key];
      },
      clear: function() {
        for (const key in memoryStorage) {
          if (memoryStorage.hasOwnProperty(key)) {
            delete memoryStorage[key];
          }
        }
      },
      key: function(index) {
        const keys = Object.keys(memoryStorage);
        return keys[index] || null;
      },
      get length() {
        return Object.keys(memoryStorage).length;
      }
    };
  }

  /**
   * Install storage stub as a property replacement
   */
  function installStorageStub(propertyName) {
    try {
      Object.defineProperty(window, propertyName, {
        value: createStorageStub(),
        writable: false,
        enumerable: true,
        configurable: false
      });
    } catch (e) {
      console.warn('Could not install ' + propertyName + ' stub:', e);
    }
  }

  // Test and potentially replace sessionStorage
  try {
    const s = window.sessionStorage;
    if (!isStorageAccessible(s)) {
      installStorageStub('sessionStorage');
    }
  } catch (e) {
    // The getter itself threw SecurityError - install stub
    installStorageStub('sessionStorage');
  }

  // Also wrap localStorage for consistency (though it's less commonly restricted)
  try {
    const l = window.localStorage;
    if (!isStorageAccessible(l)) {
      installStorageStub('localStorage');
    }
  } catch (e) {
    // The getter itself threw SecurityError - install stub
    installStorageStub('localStorage');
  }
})();
